export default [
  {
    title: 'Dashboards',
    icon: 'icon-0-icons-dark-house-copy',
    route: 'dashboard-ecommerce',
  },
]
